<div class="wysiwyg-editor">
  <quill-editor
    [class.hideToolbar]="readonly"
    [styles]="styles"
    [modules]="modules"
    [formControl]="control"
    (onFocus)="onFocus.emit(); focused = true"
    (onBlur)="onBlur.emit(); focused = false"
    (onEditorCreated)="editorReady($event)"
    (onContentChanged)="textChanged($event)"
    [maxLength]="maxLength"
    [placeholder]="placeholder">
    <div quill-editor-toolbar class="ql-toolbar ql-snow" role="toolbar">
      <span class="ql-formats">
        <button
          type="button"
          class="ql-bold"
          [attr.title]="TOOLTIP_MAP.bold"
          [attr.aria-label]="TOOLTIP_MAP.bold"></button>
        <button
          type="button"
          class="ql-italic"
          [attr.title]="TOOLTIP_MAP.italic"
          [attr.aria-label]="TOOLTIP_MAP.italic"></button>
        <button
          type="button"
          class="ql-underline"
          [attr.title]="TOOLTIP_MAP.underline"
          [attr.aria-label]="TOOLTIP_MAP.underline"></button>
        <button
          type="button"
          class="ql-strike"
          [attr.title]="TOOLTIP_MAP.strike"
          [attr.aria-label]="TOOLTIP_MAP.strike"></button>
      </span>
      <span class="ql-formats">
        <button
          type="button"
          class="ql-list"
          value="ordered"
          [attr.title]="TOOLTIP_MAP.orderedList"
          [attr.aria-label]="TOOLTIP_MAP.orderedList"></button>
        <button
          type="button"
          class="ql-list"
          value="bullet"
          [attr.title]="TOOLTIP_MAP.unorderedList"
          [attr.aria-label]="TOOLTIP_MAP.unorderedList"></button>
      </span>
      <span class="ql-formats">
        <button
          type="button"
          class="ql-indent"
          value="-1"
          [attr.title]="TOOLTIP_MAP.indent"
          [attr.aria-label]="TOOLTIP_MAP.indent"></button>
        <button
          type="button"
          class="ql-indent"
          value="+1"
          [attr.title]="TOOLTIP_MAP.outdent"
          [attr.aria-label]="TOOLTIP_MAP.outdent"></button>
      </span>
      <span class="ql-formats">
        <button
          type="button"
          class="ql-clean"
          [attr.title]="TOOLTIP_MAP.clean"
          [attr.aria-label]="TOOLTIP_MAP.clean"></button>
      </span>
    </div>
  </quill-editor>
  <div class="counter-container">
    <div [hidden]="!showCurrentLength || readonly" [class.invalid]="!isValid" class="counter">
      {{ (currentLength$ | async) - 1 }}/{{ maxLength }}
    </div>
  </div>
</div>
